<template>
  <el-dialog
    :title="(this.rowData && this.rowData.id) ? '编辑' : '添加用户'"
    :visible.sync="visibleSelf"
    width="25%"
    :destroy-on-close="true"
    @close="handleClose"
    @open="handleOpen"
  > 
    <div class="cls-add-user">
      <el-form :model="userForm" ref="userForm" label-position="top" :rules="rules">
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="userForm.userName" style="width: 300px;" placeholder="请输入用户名,最长20字" :minlength="1" :maxlength="20" show-word-limit/>
        </el-form-item>
        <el-form-item v-if="!(rowData && rowData.id)" label="初始密码" prop="initPwd">
          <el-input v-if="userForm.initPwd" v-model="userForm.initPwd" class="cls-add-user__initPwd" :readonly="true"></el-input>
          <el-button v-else @click="genInitPwd">生成8位初始密码</el-button>
        </el-form-item>
        <el-form-item label="机构" prop="organization">
          <el-input v-model="userForm.organization" style="width: 300px;" placeholder="请输入机构名称" :minlength="1" :maxlength="100" show-word-limit/>
        </el-form-item>
        <el-form-item label="设置角色" prop="userType">
          <el-select v-model="userForm.userType" placeholder="请选择" style="width: 300px;">
            <el-option v-for="item in userTypeArr" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="cls-add-user__footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="saveUser('userForm')">{{(this.rowData && this.rowData.id) ? '保存' : '添加'}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "Add-User",
  props: {
    'visible': {
      type: Boolean,
      default: false
    },
    'rowData': {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      visibleSelf: this.visible,
      userForm: {
        userName: '',
        initPwd: '',
        organization: '',
        userType: 20 // 默认普通用户
      },
      userTypeArr: [
        {'value': 10, 'label': '系统管理员'},
        {'value': 20, 'label': '普通用户'},
      ],
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 0, max: 20, message: '最长20字', trigger: 'blur' }
        ],
        organization: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        initPwd: [
          { required: true, message: '请生成初始密码', trigger: 'blur' }
        ],
        userType: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        }
    };
  },
  watch: {
    visible(newVal){
      this.visibleSelf = newVal
    },
  },
  methods: {
    genInitPwd(){
      let code = '';//声明一个空的字符串值用于后面赋值
      const codeLength = 8; //初始密码的长度，可以根据个人需求改变
      const random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm',
          'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 
          'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
          for (let i = 0; i < codeLength; i++) {
          //循环遍历codeLength，值是几，就循环几次
          let index = Math.floor(Math.random() * random.length); //Math.floor方法用于返回小于或等于一个给定数字的最大整数；Math.random方法返回 0（含）和 1（不含）之间的随机数
          code += random[index]; //根据索引取得随机数加到code上
        }
        this.userForm.initPwd = code
    },
    handleOpen(){
      if (this.rowData && JSON.stringify(this.rowData) !== '{}') {
        this.userForm = this.rowData
      } else {
        this.initUserForm()
      }
    },
    handleClose() {
      this.$bus.$emit('closeSaveUser', false)
      this.initUserForm()
    },
    cancel(){
      this.handleClose()
    },
    saveUser(userForm){
      this.$refs[userForm].validate((valid) => {
        if (valid) {
          this.save() // 保存用户
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 保存用户
    save(){
      this.$http.post('/aigenai/user/save', {...this.userForm}).then(
        res=>{
          if (res.code !== 0) return
          // 保存用户成功之后操作
          this.$emit('saveUserAfter')
          // 初始化用户数据
          this.initUserForm()
        }
      ).catch(err=>{console.log('err', err)})
    },
    // 初始化用户数据
    initUserForm(){
      this.userForm = {
        userName: '',
        initPwd: '',
        organization: '',
        userType: 20
      }
    }
  }
}
</script>
<style lang="less" scoped>
.cls-add-user{
  &__initPwd{
    width: 300px;
  }
  &__footer{
    display: flex;
    margin-bottom: 0;
    justify-content: right;
    margin-top: 50px
  }
}
</style>